import { AppRoutes } from '@/common/routes';

function App() {
  return <AppRoutes />;
}

export default App;
